import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils, isMastertrust } from '@app/_helpers';
import { SwastikaMarginSummary } from '@app/modules/trading/modules/profile/components/funds/funds.models';
import { map } from 'rxjs/operators';
import { ConfigurationService } from '../configuration/configuration.service';
import { AllMarginResponse, MarginBlocked, StatementRequest, StatementResponse, SwastikaMarginResponse } from './funds.interface';
import { PLANS_REDIRECTION_URl } from '@app/_shared/strings';

@Injectable({
  providedIn: 'root'
})
export class FundsService {



  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient
  ) { }


  // Get funds URL
  getPayinUrl(redirectToPlans?: boolean) {
    return this.http.get<any>(this.configurationService.applicationUrls.payin, {
      ...(redirectToPlans && { params: { redirectEndPoint: PLANS_REDIRECTION_URl } })
    });
  }

  // Verify Payment Status
  checkPaymentStatus(transactionId) {
    return this.http.get<any>(this.configurationService.applicationUrls.status + transactionId);
  }

  // Margin Call
  fetchMargin(isSwastikaLogin: boolean = false, isMastertrustLogin: boolean = false): any {
    if (isSwastikaLogin) {
      const headers = Utils.getRequestHeadersSwastika();
      return this.http.get<SwastikaMarginResponse>(this.configurationService.applicationUrls.fetchSwastikaMargin, { headers })
        .pipe(
          map((res) => {
            return new SwastikaMarginSummary(res);
          })
        )
    } else if (isMastertrustLogin) {
      const headers = Utils.getRequestHeadersMastertrust();
      return this.http.get<SwastikaMarginResponse>(this.configurationService.applicationUrls.fetchMastertrustMargin, { headers })
        .pipe(
          map((res) => {
            return new SwastikaMarginSummary(res);
          })
        )
    }
    else {
      return this.http.get<AllMarginResponse>(this.configurationService.applicationUrls.fetchMargin);
    }
  }


  // Transaction Details Call
  getTransactionsDetails(request: StatementRequest) {
    return this.http.get<StatementResponse>(this.configurationService.applicationUrls.transactionHistory,
      {
        params: request as any
      });
  }

  // Margin Blocked Call
  getMarginBlocked() {
    return this.http.get<MarginBlocked[]>(this.configurationService.applicationUrls.marginBlocked);
  }
}
